const Blog = () => import( /* webpackChunkName: "Blog" */ "@/views/blog/Blog");
const BlogList = () => import( /* webpackChunkName: "Blog List" */ "@/views/blog/BlogList");
const BlogNew = () => import( /* webpackChunkName: "Blog New" */ "@/views/blog/BlogNew");
const BlogDetails = () => import( /* webpackChunkName: "Blog Details" */ "@/views/blog/BlogDetails");
const BlogLikes = () => import( /* webpackChunkName: "Blog Likes" */ "@/views/blog/BlogLikes");
const blogRoutes = [{
  path: "blog",
  name: "Blog",
  redirect: {
    name: "Blog List"
  },
  component: Blog,
  children: [{
      path: "list",
      name: "Blog List",
      component: BlogList
    },
    {
      path: "new",
      name: "Blog New",
      component: BlogNew
    },
    {
      path: "edit/:id",
      name: "Blog Edit",
      component: BlogNew,
      props: true
    },
    {
      path: "likes/:id",
      name: "Blog Likes",
      component: BlogLikes,
      props: true
    },
    {
      path: "details/:id",
      name: "Blog Details",
      component: BlogDetails,
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params.id) {
          next();
        } else {
          next({
            name: from.name
          });
        }
      }
    }
  ]
}];

export default blogRoutes;
